import(/* webpackMode: "eager" */ "/data/web/oneroof-rebuild/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/breadcrumb/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SkeletonCard"] */ "/data/web/oneroof-rebuild/src/app/_components/card/builder/displayHome/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SkeletonCard"] */ "/data/web/oneroof-rebuild/src/app/_components/card/listings/standard/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewLayer"] */ "/data/web/oneroof-rebuild/src/app/_components/dataLayer/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/imageBgLoading/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/share/email.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/share/facebook.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/share/linkedin.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/share/twitter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/builder/detail/[slug]/_modules/cover/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/builder/detail/[slug]/_modules/displayHome/content.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/builder/detail/[slug]/_modules/property/content.js");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneButton","EmailButton"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/builder/detail/[slug]/_modules/topBar/button/index.js");
